
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';

import { GetBedTags, AddBedTag } from '../../redux/actions/SettingAction'
import { SuccessToast, ErrorToast } from '../../redux/actions/ToasterAction';
import { ShowSpinner, HideSpinner } from '../../redux/actions/SpinnerAction';

import ProInputText from "../../components/common/ProInputText";
import ProCheckBox from "../../components/common/ProCheckbox";
import ProTextArea from "../../components/common/ProTextArea";

import { useFormik } from "formik";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useDialogService } from '../../hooks/useDialogService';

import { Severity } from '../../constants/ProConstants';
import { duplicateCheck } from "../../utilities/Helper"
import _ from 'lodash'

const initialState = {
    name: '',
    description: '',
    isActive: true,
    shortName: ''
};
const ManageBedTags = ({ globalFilter, toggleSideBar, addNew }) => {   
    const [formData, setFormData] = useState(initialState)
    const [headingText, setHeadingText] = useState('Add New Bed Tag');
    const {actions:{ShowDialog}} = useDialogService();
    const { height } = useWindowDimensions();

    let items = [
        { label: 'Edit', icon: 'fas fa-edit', command: (e) => { onEdit(e) } },
    ];

    const allBedTags = useSelector((state) => {
        return state.setting.allBedTags;
    })

    const dispatch = useDispatch();
    const GetAllBedTags = useCallback(async (node, data) => {
        dispatch(ShowSpinner());
        var action = await GetBedTags();
        dispatch(action);
        dispatch(HideSpinner());       

    }, [dispatch])


    useEffect(() => {
        GetAllBedTags();
    }, [GetAllBedTags]);

    const onEdit = (e) => {
        setFormData(e.item.data)
        setHeadingText('Edit Bed Tag');
        addNew()
    }

    const toggleMenu = (menu, event, rowData) => {
        items.forEach((menuItem) => {
            menuItem.data = rowData;
        });
        menu && menu.toggle(event);
    }

    const actionBodyTemplate = (rowData) => {
        return (          
            <React.Fragment>
                <i className="pi pi-ellipsis-h" onClick={(event) => toggleMenu(rowData.menuRef, event, rowData)}></i>
                <Menu model={items} popup ref={(el) => rowData.menuRef = el} />
            </React.Fragment>
        );
    }

    const formik = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(_.trim(data.name))) {
                errors.name = `Name is required.`;
            }
            if (!_.isEmpty(data.name) && data.name.length > 120) {
                errors.name = "Max 120 characters allowed";
            }
            if (_.isEmpty(_.trim(data.shortName))) {
                errors.shortName = `Short Name is required.`;
            }
            if (!_.isEmpty(data.shortName) && data.shortName.length > 30) {
                errors.shortName = "Max 30 characters allowed";
            }
            if (!_.isEmpty(data.name) && duplicateCheck(allBedTags, 'name', data)) {
                errors.name = "Bed type name already exists!";
            }
            if (!_.isEmpty(data.description) && data.description.length > 500) {
                errors.description = "Max 500 characters allowed";
            }
            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    });

    const resetFormik = useCallback(() => {
        setFormData(initialState)
        formik.resetForm()
        addNew();
        setHeadingText('Add New Bed Tag');
    }, [formik, addNew])


    const handleSubmit = useCallback(async (data) => {
        try {
            data = _.omit(data, ['menuRef']);
            data.name = _.trim(data.name);
            dispatch(ShowSpinner());
            var action = await AddBedTag(data);
            dispatch(action);
            dispatch(HideSpinner());
            if (data.id) {
                dispatch(SuccessToast('Success', 'Updated Successfully!'));
            } else {
                dispatch(SuccessToast('Success', 'Saved Successfully!'));
            }
            GetAllBedTags();
        }
        catch(err) {
            dispatch(HideSpinner());
            dispatch(ErrorToast('Error', _.get(err, 'response.data.message')));
        }
        resetFormik()
    }, [dispatch, GetAllBedTags, resetFormik])

    const handleActiveChanged = async (checked)=>{
        if(!checked){
            await ShowDialog(`Inactivate ${formik.values.name} Bed Tag?`, null,null, "Yes, Inactivate", "Cancel", Severity.Danger,
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: checked})
                        },
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: true })
                        })
        }else{
            formik.setValues({ ...formik.values, isActive: checked })
        }
    }

    return (<div>
        <Sidebar onHide={() => { resetFormik() }} dismissable={false} modal={false}
            visible={toggleSideBar} position="right"
            style={{ width: '30em', zIndex: 1103 }} icons={() => (
                <h6 className="p-sidebar-close"
                    style={{
                        fontWeight: '700', fontSize: '20px', width: '100%',
                        margin: 'auto'
                    }}>{headingText}</h6>
            )}>
            <form onSubmit={formik.handleSubmit}>
                <ProInputText
                    headerText="Name"
                    id="name"
                    labelText="Name"
                    formik={formik}
                    name="name"
                    error="name"
                    required
                    value={formik.values.name}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, name: e.target.value });
                    }}
                />
                <ProInputText
                    headerText="Short Name"
                    id="shortName"
                    labelText="Short Name"
                    formik={formik}
                    name="shortName"
                    error="shortName"
                    required
                    value={formik.values.shortName}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, shortName: e.target.value });
                    }}
                />
                <ProTextArea
                    rows={7} cols={30}
                    headerText="Description"
                    id="description"
                    labelText="Description"
                    value={formik.values.description}
                    formik={formik}
                    name="description"
                    error="description"
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, description: e.target.value });
                    }}
                    showCounter
                />
                <ProCheckBox
                    id="isActive"
                    name="isActive"
                    labelText="Active"
                    checked={formik.values.isActive}
                    onChange={(e) =>handleActiveChanged(e.target.checked)}
                />
                <div className="p-d-flex p-jc-start" style={{ marginTop: "25px" }}>
                    <Button label="Cancel" type="button" className="p-button-text" onClick={() => { resetFormik() }} style={{ color: "#34436d" }} />
                    <Button label="Save" type="submit" style={{ backgroundColor: "#34436d" }} />
                </div>
            </form>
        </Sidebar>

        <DataTable value={allBedTags}
            dataKey="id"
            breakpoint="960px"
            header="Bed Tags"
            globalFilter={globalFilter}
            responsiveLayout="stack"
            scrollable scrollHeight={`${height-225}px`}>           
            <Column field="name" header="Name" sortable></Column>
            <Column field="shortName" header="Short Name" sortable></Column>
            <Column field="description" header="Description" sortable style={{ width: '30%' }}></Column>
            <Column field="isActive"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.isActive ? 'active' : 'inactive'}`}>{rowData.isActive ? 'Active' : 'Inactive'}</span>;
                }}
                header="Active" sortable></Column>
            <Column body={actionBodyTemplate} style={{ width: '5%' }}></Column>
        </DataTable>
    </div>)

}

export default ManageBedTags;